module.exports = __webpack_public_path__ + "static/media/banner1.5a0b9ff8.png";